import { GET_TIMESHEET_TEMPLATE } from "../actions/types";

const initialState = {
  timesheetTemplate: []
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_TIMESHEET_TEMPLATE:
      return {
        ...state,
        timesheetTemplate: action.payload
      };
    default:
      return state;
  }
}
